import RegisterProxy from './RegisterProxy';

export default RegisterProxy;